<template>
  <div id="div-txt-helpcookie">
    <h5>Eliminando o cache do seu navegador para voltar a acessar o Bella da Semana</h5>

    <p>Para sanar o problema, sugerimos seguir os passos abaixo:</p>
    <ol>
      <li>
        Verifique sempre se ao entrar no ensaio, você visualize seu nome no canto superior direito
        do site, assim: <strong>Bem vindo SEU NOME</strong>. Se não estiver vendo significa que você
        <u>não está logado (autenticado) em nosso site</u>, o que requer fazer um acesso usando seu
        usuário e senha;<br /><br />
      </li>
      <li>
        Verifique se a data e hora de seu computador estão corretos. Atribua também o fuso horário
        correto em seu sistema operacional. Diferença de horário no mesmo fuso, entre o nosso
        servidor e seu computador/celular, pode causar problemas de acesso após realizar login;<br /><br />
      </li>
      <li>
        Se os passos acima estiverem corretos, agora é hora de limpar o CACHE do navegador. Para
        isso, primeiro, faço o LOGOUT no canto superior direito do site do Bella. Em seguida, inicie
        a limpeza dos dados de cache conforme seu navegador. Abaixo um atalho para o suporte do
        fabricante, explicando como fazer:<br />
        <ul style="margin-left: 50px">
          <li>
            <a
              href="https://support.microsoft.com/pt-br/help/10607/microsoft-edge-view-delete-browser-historyr"
              target="_blank"
              >Microsoft Edge</a
            ><br />
          </li>
          <li>
            <a
              href="https://support.google.com/accounts/answer/32050?co=GENIE.Platform%3DDesktop&amp;hl=pt-BRr"
              target="_blank"
              >Google Chrome</a
            ><br />
          </li>
          <li>
            <a
              href="https://support.mozilla.org/pt-BR/kb/como-limpar-cache-firefoxr"
              target="_blank"
              >Mozilla Firefox</a
            ><br />
          </li>
          <li>
            <a
              href="https://support.apple.com/pt-br/guide/safari/sfri11471/13.0/mac/10.15r"
              target="_blank"
              >Apple Safari</a
            ><br />
          </li>
        </ul>
        <br /><br />
      </li>
      <li>Quando a limpeza finalizar, feche o seu navegador;<br /><br /></li>
      <li>
        Abra novamente seu navegador, se possível em uma JANELA ANÔNIMA, o que irá garantir ainda
        mais que nenhum dado incorreto de navegações anteriores seja utilizado;<br /><br />
      </li>
    </ol>
    <p>
      Caso o problema persista, por favor, ENTRE EM CONTATO explicando seu problema e contendo
      também as seguintes informações:
    </p>
    <ol>
      <li>Qual dispositivo está usando (PC ou telefone) e qual modelo?</li>
      <li>Qual navegador está usando?</li>
      <li>Qual o login (email) está usando para entrar no site?</li>
      <li>
        Anexar um print da tela (printscreen/snapshot) no momento do problema, onde aparece o erro.
      </li>
    </ol>
    <p>
      Este tipo de informação é muito valiosa para a equipe de desenvolvimento, que ai poderá fazer
      uma investigação mais a fundo e chegar rapidamente na solução para seu problema.
    </p>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'FaqPhotos'
  })
</script>

<style scoped lang="css">
  #div-txt-helpcookie {
    color: black;
  }
</style>
